import React, { FC, useContext } from 'react'
import { Route, useRouteMatch } from 'react-router-dom'
import NavWrapper from '../components/wrappers/NavWrapper'
import InternalNavigation from '../pages/statistics/InternalNavigation'
import { userContext } from '../utils/userContext'

const StatsManagementRouter: FC = () => {
    let match = useRouteMatch()
    const { hasModule } = useContext(userContext)

    return (
        <NavWrapper pageName="Statistik">
            {!hasModule(match.url) ?
                <Route component={() => <div>Du har ikke adgang til statistik</div>}/>
            :
                <InternalNavigation />
            }
        </NavWrapper>
      )
}

export default StatsManagementRouter
